import React from 'react'
import { CheckboxField } from '@toasttab/buffet-pui-forms'
import { CheckoutProps } from './useCheckoutProps'
import { t } from '@local/translations'

interface MarketingCheckboxesProps {
  checkoutProps: CheckoutProps
}

/**
 * Marketing consent checkboxes for checkout form.
 * Handles SMS and email marketing opt-ins.
 */
export const MarketingCheckboxes = ({
  checkoutProps
}: MarketingCheckboxesProps) => {
  const { showSmsMarketingCheckbox } = checkoutProps
  return (
    <div className='px-6 pb-2'>
      {showSmsMarketingCheckbox && (
        <CheckboxField
          containerClassName='-mb-4'
          testId='sms-marketing-consent-checkbox'
          label={t('marketing-checkboxes.sms-marketing-consent')}
          name='marketingConsent.isSmsMarketingConsentGiven'
        />
      )}
      <CheckboxField
        testId='email-marketing-consent-checkbox'
        label={t('marketing-checkboxes.email-marketing-consent')}
        name='marketingConsent.isEmailMarketingConsentGiven'
      />
    </div>
  )
}
